export default __webpack_public_path__ + "static/media/logo-switch.f76a1f34.svg";